import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "",
  style: {"overflow":"auto","position":"sticky","top":"0","height":"14px"}
}, null, -1)
const _hoisted_2 = {
  class: "mt-0 mx-4 mb-0 rounded-3xl bg-white shadow-xl navbg dark",
  style: {"overflow":"auto","position":"sticky","top":"14px","z-index":"100"}
}
const _hoisted_3 = { class: "max-w-7xl mx-auto px-2 md:px-6 lg:px-8" }
const _hoisted_4 = { class: " flex items-center justify-center sm:h-0 md:h-16 lg:h-16" }
const _hoisted_5 = { class: "flex h-full" }
const _hoisted_6 = { class: "hidden md:block md:ml-6" }
const _hoisted_7 = { class: " mx-2 flex justify-between h-full items-center" }
const _hoisted_8 = { class: "mx-2 flex-1" }
const _hoisted_9 = {
  id: "mobile-menu",
  class: "md:hidden",
  style: {"overflow":"hidden"}
}
const _hoisted_10 = {
  class: "flex justify-between items-center h-14 md:h-0 ml-9 mr-8",
  style: {"overflow":"hidden"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLogo = _resolveComponent("HeaderLogo")
  const _component_HeaderItem = _resolveComponent("HeaderItem")
  const _component_rating_dialog = _resolveComponent("rating-dialog")
  const _component_AvatarMenuItem = _resolveComponent("AvatarMenuItem")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("nav", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_HeaderLogo, { "css-class": "mx-2 flex-none" }),
                _createVNode(_component_HeaderItem, {
                  "aria-label": "feed",
                  "css-class": "mx-2 flex-1",
                  "item-icon-pre": "home_icon",
                  "item-text": "",
                  link: "/feed/items",
                  "active-route-list": ['/feed/boostpacks', '/feed/items']
                }),
                _createVNode("div", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "ratingButton", {}, () => [
                    _createVNode(_component_rating_dialog)
                  ])
                ]),
                (!_ctx.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_HeaderItem, {
                      key: 0,
                      "css-class": "mx-2 flex-1",
                      "item-icon-pre": "user_icon",
                      "item-text": "",
                      link: "/login",
                      "active-route-list": ['/login', '/register', '/forgot-password']
                    }))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("div", null, [
                  _createVNode(_component_router_link, { to: "/profile/shared" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AvatarMenuItem)
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.isAuthenticated]
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_HeaderLogo, {
            "css-class": "flex-none",
            "logo-padding": ""
          }),
          _createVNode(_component_HeaderItem, {
            "aria-label": "feed",
            "css-class": "flex-none",
            "item-icon-pre": "home_icon",
            "item-width": "auto",
            link: "/feed/items",
            "active-route-list": ['/feed/boostpacks', '/feed/items']
          }),
          _renderSlot(_ctx.$slots, "ratingButton", {}, () => [
            _createVNode(_component_rating_dialog)
          ]),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_HeaderItem, {
                key: 0,
                "css-class": "flex-none",
                "item-icon-pre": "user_icon",
                "item-text": "",
                "item-width": "auto",
                link: "/login",
                "active-route-list": ['/login', '/register', '/forgot-password']
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}